import { MockMethod } from 'vite-plugin-mock'
import { SUCCESS_CODE } from '@/constants'

const timeout = 1000

const adminList = [
  {
    path: '/system',
    component: '#',
    redirect: '/system/user',
    name: 'System',
    meta: {
      title: '系统管理',
      icon: 'carbon:skill-level-advanced',
      alwaysShow: true
    },
    children: [
      {
        path: 'user',
        name: 'User',
        component: 'views/System/User',
        meta: {
          title: '用户管理'
        }
      },
      {
        path: 'role',
        name: 'Role',
        component: 'views/System/Role',
        meta: {
          title: '角色管理'
        }
      }
    ]
  },
  {
    path: '/box',
    component: '#',
    redirect: '/views/Level/workbin',
    name: 'Box',
    meta: {
      title: '箱子管理',
      icon: 'carbon:box',
      alwaysShow: true
    },
    children: [
      {
        path: 'workbin',
        name: 'Menu2Dem',
        component: 'views/Level/workbin/workbin',
        meta: {
          title: '料箱管理'
        },
        children: [
          {
            path: 'workbinAdd',
            component: 'views/Level/workbin/workbinAdd',
            name: 'workbinAdd',
            meta: {
              title: 'router.exampleAdd',
              noTagsView: true,
              noCache: true,
              hidden: true,
              showMainRoute: true,
              activeMenu: 'views/Level/workbin'
            }
          },
          {
            path: 'workbinEdit',
            component: 'views/Level/workbin/workbinEdit',
            name: 'workbinEdit',
            meta: {
              title: 'router.exampleEdit',
              noTagsView: true,
              noCache: true,
              hidden: true,
              showMainRoute: true,
              activeMenu: 'views/Level/workbin'
            }
          }
        ]
      },
      {
        path: 'box-collection',
        component: 'views/Box/Collection/CollectionPage',
        name: 'CollectionPage',
        meta: {
          title: '集合箱列表'
        }
      },
      {
        path: 'box-collection-detail',
        component: 'views/Box/Collection/CollectionDetail',
        name: 'BoxCollectionDetail',
        meta: {
          title: '集合箱详情',
          noTagsView: true,
          noCache: true,
          hidden: true,
          showMainRoute: true,
          activeMenu: '/box/box-collection'
        }
      }
    ]
  },
  {
    path: '/task',
    component: '#',
    redirect: '/task/call-box-putaway',
    name: 'Task',
    meta: {
      title: '任务管理',
      icon: 'hugeicons:task-daily-01',
      alwaysShow: true
    },
    children: [
      {
        path: 'call-box-putaway-detail',
        name: 'CallBoxPutawayDetail',
        component: 'views/Task/CallBoxPutaway/detail',
        meta: {
          noTagsView: true,
          noCache: true,
          hidden: true,
          showMainRoute: true,
          title: '叫箱上架详情'
        }
      },
      {
        path: 'call-box-putaway-list',
        name: 'CallBoxPutawayList',
        component: 'views/Task/CallBoxPutaway/list',
        meta: {
          title: '叫箱上架列表'
        }
      },
      {
        path: 'call-box-putaway',
        name: 'CallBoxPutaway',
        component: 'views/Task/CallBoxPutaway/select',
        meta: {
          title: '叫箱上架'
        }
      }
    ]
  }
]

const testList: string[] = [
  '/system',
  '/system/user',
  '/Box',
  '/Box/box-collection',
  '/Box/box-collection/detail',
  '/task',
  '/task/call-box-putaway/detail',
  '/task/call-box-putaway/list',
  '/task/call-box-putaway/select'
]

export default [
  // 列表接口
  {
    url: '/mock/role/list',
    method: 'get',
    timeout,
    response: ({ query }) => {
      const { roleName } = query
      return {
        code: SUCCESS_CODE,
        data: roleName === 'admin' ? adminList : testList
      }
    }
  }
] as MockMethod[]
